import { Box, Button, Stack } from "@compass/core";
import { CustomFilter as CustomFilterModel, CustomFilterOperator, ReportPropertyBase } from "generated/openApi";
import produce from "immer";
import { CustomFilter } from "./CustomFilter";

export const CustomFilters = (props: {
  filters: CustomFilterModel[] | undefined;
  setFilters: (filters: CustomFilterModel[] | undefined) => void;
  properties: ReportPropertyBase[] | undefined;
}) => {
  return (
    <Stack direction="column" spacing="sm">
      {props.filters?.map((filter, index) => (
        <CustomFilter
          filter={filter}
          setFilter={(filter) =>
            props.setFilters(
              produce(props.filters, (draft) => {
                draft![index] = filter;
              })
            )
          }
          removeFilter={() =>
            props.setFilters(
              produce(props.filters, (draft) => {
                draft!.splice(index, 1);
              })
            )
          }
          properties={props.properties}
        />
      ))}

      <Box>
        <Button
          onClick={() =>
            props.setFilters(
              props.filters
                ? [
                    ...props.filters,
                    {
                      operator: CustomFilterOperator.Equal,
                    } as CustomFilterModel,
                  ]
                : [{ operator: CustomFilterOperator.Equal } as CustomFilterModel]
            )
          }
          variant="outlined"
        >
          + Smart Filter
        </Button>
      </Box>
    </Stack>
  );
};
